module.exports = __webpack_public_path__ + "img/unselectedfolder.e9b2fe6a.svg";